export const Debug = 'debug';
export const UI = 'ui';
export const V3dLogic = 'logic';
export const Language = 'lang';
